import React from 'react'
import './Coursecard.css'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import { Link } from 'react-router-dom';
import img1 from '../../assets/coursecard/1.jpg'
import img2 from '../../assets/coursecard/2.jpg'
import img3 from '../../assets/coursecard/3.jpg'
import img4 from '../../assets/coursecard/4.jpg'
import img5 from '../../assets/coursecard/5.jpg'
import img6 from '../../assets/coursecard/6.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)

const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };

const Coursecard = () => {
  return (
    <div class="course-card-section ws-section pb-05">
        <div class="container text-center">
        <div class="row">
            <div class="col-lg">
                <h2 class="ws-section_heading pd-03">Prepare for a Successful VLSI Career with a Solid Base</h2>
            </div>
        </div>
        <Carousel responsive={responsive} arrows={false} showDots={true} autoPlay={true} infinite={true}
        >
        <div class="p-4">
        <a href="/product/physical-design">
        <div class="course-card-box">
            <div class="card-box-thumbnail">
                <img src={img1} alt=''/>
            </div>
            <div class="card-box-bottom">
                <div class="card-box-rating">Discover, Learn, Grow</div>
                <div class="card-content-title mb-lg-3">Physical Design</div>
                <div class="card-box-duration d-flex justify-content-between">
                    <div className='align-self-center'><FontAwesomeIcon icon="fa-solid fa-clock" /> <span className='ps-2'>5 Months | View Now</span> </div>
                    <div>
                        
                        <button className='card-btn'><FontAwesomeIcon icon="fa-solid fa-check" /> Enrol Now</button>
                       
                        </div>
                </div>
            </div>
        </div>
        </a>
        </div>
        <div class="p-4">
        <a href="/product/analog-layout-design/">
        <div class="course-card-box">
            <div class="card-box-thumbnail">
                <img src={img4} alt=''/>
            </div>
            <div class="card-box-bottom">
                <div class="card-box-rating">Discover, Learn, Grow</div>
                <div class="card-content-title mb-lg-3">Analog Layout Design
                </div>
                <div class="card-box-duration d-flex justify-content-between">
                    <div className='align-self-center'><FontAwesomeIcon icon="fa-solid fa-clock" /> <span className='ps-2'>4 Months | View Now</span> </div>
                    <div>
                        
                        <button className='card-btn'><FontAwesomeIcon icon="fa-solid fa-check" /> Enrol Now</button>
                        
                        </div>
                </div>
            </div>
        </div>
        </a>
        </div>
        
        <div class="p-4">
            <a href="/product/asic-verification/"></a>
        <div class="course-card-box">
            <div class="card-box-thumbnail">
                <img src={img3} alt=''/>
            </div>
            <div class="card-box-bottom">
                <div class="card-box-rating">Discover, Learn, Grow</div>
                <div class="card-content-title mb-lg-3">ASIC Verification
                </div>
                <div class="card-box-duration d-flex justify-content-between">
                    <div className='align-self-center'><FontAwesomeIcon icon="fa-solid fa-clock" /> <span className='ps-2'>5 Months | View Now</span> </div>
                     <div>
                        
                        <button className='card-btn'><FontAwesomeIcon icon="fa-solid fa-check" /> Enrol Now</button>
                        </div>
                </div>
            </div>
        </div>
        </div>
        <div class="p-4">
            <a href="/product/design-for-test/">
        <div class="course-card-box">
            <div class="card-box-thumbnail">
                <img src={img2} alt=''/>
            </div>
            <div class="card-box-bottom">
                <div class="card-box-rating">Discover, Learn, Grow</div>
                <div class="card-content-title mb-lg-3">Design For Test (DFT)</div>
                <div class="card-box-duration d-flex justify-content-between">
                    <div className='align-self-center'><FontAwesomeIcon icon="fa-solid fa-clock" /> <span className='ps-2'>4 Months | View Now</span> </div>
                     <div>
                        <button className='card-btn'><FontAwesomeIcon icon="fa-solid fa-check" /> Enrol Now</button>
                        </div>
                </div>
            </div>
        </div>
        </a>
        </div>
        
        <div class="p-4">
            <a href="/product/analog-circuit-design/">
        <div class="course-card-box">
            <div class="card-box-thumbnail">
                <img src={img6} alt=''/>
            </div>
            <div class="card-box-bottom">
                <div class="card-box-rating">Discover, Learn, Grow</div>
                <div class="card-content-title mb-lg-3">Analog Circuit Design
                </div>
                <div class="card-box-duration d-flex justify-content-between">
                    <div className='align-self-center'><FontAwesomeIcon icon="fa-solid fa-clock" /> <span className='ps-2'>16 Weeks | View Now</span> </div>
                     <div>
                        
                        <button className='card-btn'><FontAwesomeIcon icon="fa-solid fa-check" /> Enrol Now</button>
                        
                        </div>
                </div>
            </div>
        </div>
        </a>
        </div>
        <div class="p-4">
            <a href="/product/rtl-coding-fpga-design/">
        <div class="course-card-box">
            <div class="card-box-thumbnail">
                <img src={img5} alt=''/>
            </div>
            <div class="card-box-bottom">
                <div class="card-box-rating">Discover, Learn, Grow</div>
                <div class="card-content-title mb-lg-3">RTL Coding and FPGA Design
                </div>
                <div class="card-box-duration d-flex justify-content-between">
                    <div className='align-self-center'><FontAwesomeIcon icon="fa-solid fa-clock" /> <span className='ps-2'>4 Months | View Now</span> </div>
                     <div>
                        
                        <button className='card-btn'><FontAwesomeIcon icon="fa-solid fa-check" /> Enrol Now</button>
                        
                        </div>
                </div>
            </div>
        </div>
        </a>
        </div>
        <div class="p-4">
            <a href="/product/physical-design">
        <div class="course-card-box">
            <div class="card-box-thumbnail">
                <img src={img1} alt=''/>
            </div>
            <div class="card-box-bottom">
                <div class="card-box-rating">Discover, Learn, Grow</div>
                <div class="card-content-title mb-lg-3">Physical Design</div>
                <div class="card-box-duration d-flex justify-content-between">
                    <div className='align-self-center'><FontAwesomeIcon icon="fa-solid fa-clock" /> <span className='ps-2'>5 Months | View Now</span> </div>
                     <div>
                        
                        <button className='card-btn'><FontAwesomeIcon icon="fa-solid fa-check" /> Enrol Now</button>
                        
                        </div>
                </div>
            </div>
        </div>
        </a>
        </div>
        <div class="p-4">
            <a href="/product/design-for-test/">
        <div class="course-card-box">
            <div class="card-box-thumbnail">
                <img src={img2} alt=''/>
            </div>
            <div class="card-box-bottom">
                <div class="card-box-rating">Discover, Learn, Grow</div>
                <div class="card-content-title mb-lg-3">Design For Test (DFT)
                </div>
                <div class="card-box-duration d-flex justify-content-between">
                    <div className='align-self-center'><FontAwesomeIcon icon="fa-solid fa-clock" /> <span className='ps-2'>4 Months | View Now</span> </div>
                     <div>
                        
                        <button className='card-btn'><FontAwesomeIcon icon="fa-solid fa-check" /> Enrol Now</button>
                        
                        </div>
                </div>
            </div>
        </div>
        </a>
        </div>
        
        </Carousel>
    </div>
    </div>
  )
}

export default Coursecard